import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Button } from "@mui/material";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import {
  driverFieldConfiguration,
  driverInitialValues,
} from "../../../formConfigs/Fleet/driverFieldConfig";
import { apiVariable } from "../../../api/apiVariable";
import useAuth from "../../../hooks/useAuth";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";

const DriverPopup = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const queryClient = useQueryClient();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setStatus("idle");

  const { token } = useAuth();

  const driverMutation = useMutation({
    mutationFn: (data: any) =>
      axios.post(`${apiVariable}/driver`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["drivers"] });
      handleClose();
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response.data || "Failed to submit driver");
    },
  });

  const submitHandler = (data: any) => {
    driverMutation.mutate(data);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Quick Add Driver
      </Button>
      <GenericFormPopup
        formFields={driverFieldConfiguration}
        initialValues={driverInitialValues}
        title="Driver Form"
        onSubmit={submitHandler}
        open={open}
        onClose={handleClose}
        loading={driverMutation.isPending}
      />
      <StatusSnackbar
        status={status}
        successMessage="Driver created successfully"
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default DriverPopup;
